import React from 'react';
import PortfolioView from '../MyWork/index.jsx';

/**
 * Portfolio Actionables page — every client the rep owns, with their open
 * Actionables (committed work, due dates, owners). Sits in the sidebar
 * alongside Findings (the deliberation surface).
 *
 * Thin wrapper over the shared PortfolioView with kind locked to
 * 'actionables'. The shared component handles fetching, grouping, filtering,
 * inline edit, chat, etc.
 */
const Actionables = () => <PortfolioView kind='actionables' />;

export default Actionables;
